import React, { useState, useEffect } from 'react'
import { supabase } from './supabaseClient'
import { useAuth } from './AuthContext'
import { C } from './theme'
import IvaTrimestral from './IvaTrimestral'
import { Landmark, RefreshCw, Calendar, Info } from 'lucide-react'

// Aba própria do IVA. Bebe da mesma facturação importada do Sage que a Previsão
// — quando lá importas um relatório novo, isto actualiza-se sozinho.

export default function IvaPage() {
  const { isAdmin } = useAuth()
  const [declarada, setDeclarada] = useState([])
  const [loading, setLoading] = useState(true)
  const [erro, setErro] = useState('')
  const [ano, setAno] = useState(new Date().getFullYear())

  const carregar = async () => {
    setLoading(true); setErro('')
    const { data, error } = await supabase.from('faturacao_declarada')
      .select('*').order('ano').order('mes')
    if (error) setErro(error.message)
    setDeclarada(data || [])
    setLoading(false)
  }
  useEffect(() => { if (isAdmin) carregar() }, [isAdmin])

  if (!isAdmin) {
    return (
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px' }}>
        <div style={{ textAlign: 'center', color: C.textMuted }}>
          <Landmark size={40} style={{ opacity: 0.4 }} />
          <p style={{ marginTop: '12px', fontSize: '13px' }}>Só o administrador vê esta página.</p>
        </div>
      </div>
    )
  }

  const anos = [...new Set([...declarada.map(d => d.ano), new Date().getFullYear()])].sort((a, b) => b - a)
  const temDados = declarada.some(d => d.ano === Number(ano))

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', flex: 1, overflowY: 'auto' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap', marginBottom: '14px' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: C.text, display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Landmark size={20} color={C.primary} /> IVA a entregar
          </h1>
          <p style={{ margin: '4px 0 0', fontSize: '12px', color: C.textMuted }}>
            Por trimestre, a partir da facturação importada do Sage. Para saber quanto reservar — a declaração faz-se no Sage.
          </p>
        </div>
        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: C.text, fontWeight: '600' }}>
            <Calendar size={13} color={C.textMuted} />
            <select value={ano} onChange={e => setAno(Number(e.target.value))}
              style={{ padding: '5px 9px', border: `1px solid ${C.border}`, borderRadius: '4px', fontSize: '12px' }}>
              {anos.map(a => <option key={a} value={a}>{a}</option>)}
            </select>
          </label>
          <button onClick={carregar} disabled={loading}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '7px 12px', border: `1px solid ${C.border}`, borderRadius: '4px', background: C.surface, color: C.text, cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>
            <RefreshCw size={13} /> Actualizar
          </button>
        </div>
      </div>

      {erro && (
        <div style={{ padding: '10px 14px', background: C.dangerSoft, border: `1px solid ${C.danger}55`, borderRadius: '4px', color: C.danger, fontSize: '12px', marginBottom: '12px' }}>{erro}</div>
      )}

      {loading ? (
        <div style={{ padding: '40px', textAlign: 'center', color: C.textMuted, fontSize: '13px' }}>A carregar…</div>
      ) : !temDados ? (
        <div style={{ padding: '20px', background: '#eff6fc', border: `1px solid ${C.info}55`, borderRadius: '6px', fontSize: '13px', color: C.text, lineHeight: 1.7 }}>
          <Info size={15} color={C.info} style={{ verticalAlign: 'middle', marginRight: 6 }} />
          Ainda não há facturação de <strong>{ano}</strong> importada.
          <div style={{ marginTop: '8px', fontSize: '12px', color: C.textMuted }}>
            O IVA sai do <strong>Mapa de vendas do Sage</strong> — importa-o em <strong>Financeiro → Previsão</strong> e
            os trimestres aparecem aqui. O cálculo usa o IVA real de cada factura, por isso as isentas
            e as de OSS contam zero sem ninguém as ter de marcar.
          </div>
        </div>
      ) : (
        <IvaTrimestral declarada={declarada} ano={ano} sempreAberto />
      )}
    </div>
  )
}
